module.exports = __webpack_public_path__ + "img/newEnergy_solution_bg.617fce4c.png";